"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { cn } from "@/lib/utils";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "I had a lovely experience at Natalia’s Beauty! Natalia was professional, friendly, and made me feel completely comfortable throughout my appointment. The service was done with great attention to detail, and I’m so happy with the results. Highly recommend to anyone looking for quality beauty treatments in a welcoming atmosphere!",
  author: "Elena",
  position: "Regular Client",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/jane_d_avatar.png",
  initials: "ER"
}, {
  quote: "Stepping into the Brooke sanctuary is like entering another world. The deep tissue work is precise, intuitive, and profoundly healing.",
  author: "James T.",
  position: "Athlete",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/michael_s_avatar.png",
  initials: "JT"
}, {
  quote: "I had an amazing massage at Natalia’s Beauty! Natalia was professional, welcoming, and created such a relaxing atmosphere. The massage was exactly what I needed — soothing, calming, and left me feeling refreshed and stress‑free. I’ll definitely be coming back and highly recommend her services!",
  author: "Sarah L.",
  position: "New Client",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/sarah_l_avatar.png",
  initials: "SL"
}];
export default function PatientPerspectives() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="125460" id="deep-relaxation" ref={ref} className={cn("bg-background relative w-full overflow-hidden py-24 md:py-32 transition-opacity duration-500 ease-in-out", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="bg-secondary/20 absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 size-[500px] rounded-lg blur-[120px] pointer-events-none" />
      <div className="bg-accent/10 absolute bottom-0 right-0 translate-x-1/3 translate-y-1/3 size-[600px] rounded-lg blur-[140px] pointer-events-none" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center justify-center space-y-8 px-4 py-8 md:px-12">
                    <Badge variant="secondary" className="bg-accent/40 text-foreground border-border/30 shadow-sm backdrop-blur-xl px-4 py-1.5 text-xs tracking-widest uppercase font-sans">
                      The Sanctuary Experience
                    </Badge>

                    <div className="relative">
                      <Quote className="text-primary absolute -top-8 -left-8 size-16 rotate-180 opacity-20 md:-top-12 md:-left-12 md:size-24" />
                      <p className="text-foreground font-serif text-3xl leading-tight md:text-5xl lg:text-6xl lg:leading-[1.15] italic font-light tracking-tight">
                        "{testimonial.quote}"
                      </p>
                    </div>

                    <div className="flex items-center space-x-4 pt-6">
                      <SafeHydrate><Avatar className="border-border/50 size-14 border shadow-md">
                        
                        <AvatarFallback className="bg-secondary text-secondary-foreground font-medium">
                          {testimonial.initials}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-left">
                        <p className="text-foreground font-semibold text-lg tracking-wide">
                          {testimonial.author}
                        </p>
                        
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="mt-12 flex items-center justify-center space-x-3">
            {Array.from({
            length: count
          }).map((_, index) => <button key={index} data-index={index} onClick={() => api?.scrollTo(index)} aria-label={`Go to slide ${index + 1}`} className={cn("h-1.5 rounded-full transition-all duration-700 ease-in-out border border-border/20 shadow-xs backdrop-blur-sm", current === index ? "bg-primary w-12" : "bg-muted/40 hover:bg-primary/30 w-4")} />)}
          </div>
        </div>
      </div>
    </section>;
}